export const canonicalName = (name) => {
  if (!name) return ""

  return name.trim().replace(/\s+/g, " ")
}

export const scrubEnteredNameValue = (name) => name.trimStart()
